var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{ref:"td",staticClass:"keyboard-navigation",class:{
    hover: _vm.hover,
    'painted-empty': _vm.painted === 'empty',
    'painted-copy': _vm.painted === 'copy',
    'painted-copy-source': _vm.painted === 'copy-source',
  },attrs:{"tabindex":"0"},on:{"keydown":_vm.keydown,"mousedown":_vm.mousedown,"mouseup":_vm.mouseup,"mouseover":_vm.mouseover,"mouseleave":function($event){_vm.hover = false}}},[(_vm.disappearEnabled)?_c('disappearing-component',[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }